import { defineMessages } from "react-intl";

export const messages = defineMessages({
    heroHeading: {
        id: "PaidLanding.JiraAIv2.heroHeading",
        defaultMessage: "Jira for the <accent>AI</accent> era",
        description:
            "Page hero heading on the Jira frictionless first look v2 landing page. The word inside <accent> is rendered with a brand blue color."
    },
    heroSubheading: {
        id: "PaidLanding.JiraAIv2.heroSubheading",
        defaultMessage:
            "Team up with AI agents to orchestrate, plan, and track projects at scale.",
        description:
            "Page hero subheading on the Jira frictionless first look v2 landing page."
    },
    workEmailLabel: {
        id: "PaidLanding.JiraAIv2.workEmailLabel",
        defaultMessage: "Work email",
        description:
            "Label above the work email input in the embedded signup form."
    }
});
